if (!customElements.get('newsletter-resubmission')) {
  customElements.define(
    'newsletter-resubmission',
    class NewsletterResubmission extends HTMLElement {
      constructor() {
        super();
        this.content = this.querySelector('.newsletter-resubmission');
        this.checkResubmission();
      }
      checkResubmission() {
        const live_url = window.location.href;
        let result = live_url.includes("form_type=customer");
        if (!result) return;
        console.log("User has already subscribed.");
        this.content.style.display = 'block';
      }
    }
  );
}
